import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';

export interface GetParticipationAnswersParams {
	participation_id: string;
}

const Service = PsychosocialReportService.getInstance();

export const useGetParticipationAnswers = (params: GetParticipationAnswersParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_PSYCHOSOCIAL_PARTICIPATION_ANSWERS, params],
		queryFn: async () => Service.getParticipationAnswers(params),
		enabled: !!params.participation_id
	});
};
